@if (loading$ | async) {
  <div class="spinner-container">
    <mat-spinner/>
  </div>
}
